import { GetApiRequest } from '@/plugins/api/base'

export class GetUserFullData extends GetApiRequest {
  constructor(context) {
    const body = {
      Culture: context.i18n.locale.value,
    }

    const url = `/Bsw/BCService.asmx/GetUserFullData`
    super(context, url, body)
  }
}
